import { EmployeeName, Employee } from './Employee';

export type EmployeeView = Omit<Employee, 'googleId' | 'name' | 'isGoogleUser'> & EmployeeName;

export enum EmployeeViewFields {
  id = 'id',
  givenName = 'givenName',
  familyName = 'familyName',
  email = 'email',
  fullName = 'fullName',
  photoUrl = 'photoUrl',
  isAutoReportingEnabled = 'isAutoReportingEnabled',
  isArchived = 'isArchived',
  dateOfBirth = 'dateOfBirth',
  careerStartDate = 'careerStartDate',
  sex = 'sex',
  tenure = 'tenure',
  status = 'status',
  startDate = 'startDate',
  terminationDate = 'terminationDate',
  probationPeriodEndDate = 'probationPeriodEndDate',
  location = 'location',
}
